
import React from 'react';
import { Button } from "@/components/ui/button";
import { Wifi, WifiOff, RefreshCw } from "lucide-react";
import { 
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { ConnectionStatusStrict } from '@/hooks/useConnectionState';

interface ConnectionStatusIndicatorProps {
  connectionStatus: ConnectionStatusStrict;
  retryConnection: () => Promise<boolean>;
}

const ConnectionStatusIndicator = ({
  connectionStatus,
  retryConnection
}: ConnectionStatusIndicatorProps) => {
  // Render based on connection status
  if (connectionStatus === 'connected') {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button 
            variant="ghost" 
            className="h-6 w-6 p-0 text-green-500"
            disabled
          >
            <Wifi className="h-3.5 w-3.5" />
            <span className="sr-only">Đã kết nối</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <div className="text-xs font-medium">Đã kết nối đến máy chủ</div>
        </TooltipContent>
      </Tooltip>
    );
  }
  
  if (connectionStatus === 'connecting') {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button 
            variant="ghost" 
            className="h-6 w-6 p-0 text-blue-500"
            disabled
          >
            <RefreshCw className="h-3.5 w-3.5 animate-spin" />
            <span className="sr-only">Đang kết nối</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <div className="text-xs font-medium">Đang kết nối...</div>
        </TooltipContent>
      </Tooltip>
    );
  }
  
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button 
          variant="ghost" 
          className="h-6 w-6 p-0 text-red-500 hover:text-red-600 hover:bg-red-50"
          onClick={retryConnection}
        >
          <WifiOff className="h-3.5 w-3.5" />
          <span className="sr-only">Kết nối lỗi</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <div className="text-xs font-medium">Kết nối lỗi - Nhấn để thử lại</div>
      </TooltipContent>
    </Tooltip>
  );
};

export default React.memo(ConnectionStatusIndicator);
